<template>
  <div class="container">
    <el-row style="margin-bottom:20px">
        <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/director-work' }">工作台</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/director-work-project' }">立项</el-breadcrumb-item>
        <el-breadcrumb-item>立项设置</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>

    <!--暂时先用tabs  后期时间来得及可以考虑拆分成单个页面-->
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">

      <el-tab-pane label="人员设置" name="one">
        <user-set :project_id="project_id"></user-set>
      </el-tab-pane>

      <el-tab-pane label="面试设置" name="two" :lazy="true">
        <interview-set></interview-set>
      </el-tab-pane>

      <el-tab-pane label="薪资设置" name="three" :lazy="true">
        <salary-set :project_id="project_id"></salary-set>
      </el-tab-pane>

      <el-tab-pane label="合同模版" name="seven" :lazy="true">
        <contract-tpl :project_id="project_id"></contract-tpl>
      </el-tab-pane>

      <el-tab-pane label="打卡设置" name="four" :lazy="true">

        <clock-set :project_id="project_id"></clock-set>
      </el-tab-pane>

      <el-tab-pane label="审批设置" name="five" :lazy="true">
        <approval-set :project_id="project_id"></approval-set>
      </el-tab-pane>


      <el-tab-pane label="汇报设置" name="six" :lazy="true">
        <report-set :project_id="project_id"></report-set>
      </el-tab-pane>


     
    </el-tabs>
  </div>
</template>
<script>
import { addProject,projectList,companyList,updateProject,projectInfo} from "@/api/director/project/index";
import userSet from "@/views/director/work/project/setting/part/user-set.vue";
import interviewSet from "@/views/director/work/project/setting/part/interview-set.vue";
import salarySet from "@/views/director/work/project/setting/part/salary-set.vue";
import contractTpl from "@/views/director/work/project/setting/part/contract-tpl.vue";

import clockSet from "@/views/director/work/project/setting/part/clock-set.vue";
import reportSet from "@/views/director/work/project/setting/part/report-set.vue";
import approvalSet from "@/views/director/work/project/setting/part/approval-set.vue";
  export default {
    components:{
      userSet,interviewSet,salarySet,clockSet,reportSet,approvalSet,contractTpl
    },
    data() {
      return {
        activeName: 'one',
        userList:[],
        project_id:"",
        formData:{},
        form: {
         
          users:[],
          name: '',
          region: '',
          date1: '',
          date2: '',
          delivery: false,
          type: [],
          resource: '',
          desc: ''
        }
      };
    },
    mounted () {

      if(this.$route.query&&this.$route.query.project_id){
        this.project_id=this.$route.query.project_id;
        this.initProject();
      }

    },
    methods: {

      handleClick(tab, event) {
        console.log(tab, event);
      },

      initProject(){
        var that = this;
        projectInfo({project_id:that.project_id}).then((response) => {
          var info = response.data;
          this.formData=info;
        

        });
      },
    }
  };
</script>